export default __webpack_public_path__ + "static/media/mapBlackVehicle.d20ec0b6.png";